const drawer = document.querySelector('.d5-cart-left');
const rightCp = document.querySelector('.cart__right');
function hideCheckoutElement() {
  const elem = document.querySelector('.cp-checkout-d5');
  if (elem) {
    elem.setAttribute('hidden', '');
  } else {
    console.warn('Element .cp-checkout-d5 not found.');
  }
}

function showCheckoutElement() {
  const elem = document.querySelector('.cp-checkout-d5');
  if (elem) {
    elem.removeAttribute('hidden');
  } else {
    console.warn('Element .cp-checkout-d5 not found.');
  }
}

/* Fashion Nova feel: the line disappears / the quantity changes the instant the shopper taps,
   the server call and the totals refresh happen in the background (before: change.js, then a full
   /cart page download + swap, about 2 s of "loading"). */
function setCartCounts(count) {
  document.querySelectorAll('.cart-item-count-d5').forEach(el => { el.textContent = '(' + count + ' item' + (count === 1 ? '' : 's') + ')'; });
  document.querySelectorAll('.cart-count-d5').forEach(el => { el.textContent = count; });
}
function currentCartCount() {
  let n = 0;
  document.querySelectorAll('.d5-cart-left [line-item] .cd-qty-input-d5').forEach(i => { n += parseInt(i.value, 10) || 0; });
  return n;
}
function optimisticRemove(item) {
  const qty = parseInt(item.querySelector('.cd-qty-input-d5')?.value, 10) || 1;
  const count = Math.max(0, currentCartCount() - qty);
  item.style.transition = 'opacity .15s ease';
  item.style.opacity = '0';
  item.style.pointerEvents = 'none';
  setTimeout(() => item.remove(), 150);
  setCartCounts(count);
}
function optimisticQty(item, qty) {
  const input = item.querySelector('.cd-qty-input-d5');
  const before = parseInt(input.value, 10) || 0;
  input.value = qty;
  setCartCounts(Math.max(0, currentCartCount()));
  return before;
}
async function changeLine(key, qty) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  let cart = null;
  try { cart = await res.json(); } catch (e) { /* ignore */ }
  if (cart && typeof cart.item_count === 'number') setCartCounts(cart.item_count);
  return cart;
}

document.addEventListener('click', async e => {
  const minus = e.target.closest('.cd-qty-minus-d5');
  const plus = e.target.closest('.cd-qty-plus-d5');
  if (!minus && !plus) return;
  e.preventDefault();

  const item = e.target.closest('[line-item]');
  if (!item) return;
  if (!item.closest('.d5-cart-left, #mc-bag-panel')) return; /* drawer lines are handled by d5-script.js */

  const key = item.getAttribute('line-item');
  const input = item.querySelector('.cd-qty-input-d5');
  let qty = parseInt(input.value, 10);

  if (plus) qty++;

  if (minus) {
    if (qty === 1) {
      const modal = item.querySelector('#cp-remove-confirmation-modal-d5');
      const confirmBtn = modal.querySelector('.cp-confirm-remove-d5');

      const moveBtn = modal.querySelector('.cp-move-wishlist-d5');

      const confirmed = await new Promise(resolve => {
        modal.style.display = 'flex';
        confirmBtn.onclick = () => {
          modal.style.display = 'none';
          resolve(true);
        };
       document.addEventListener('click', e => {
          const cancelBtn = e.target.closest('.cp-cancel-d5');
          if (cancelBtn) {
            const modal = cancelBtn.closest('.cp-remove-confirmation-modal-d5');
            if (modal) modal.style.display = 'none';
          }
        });

        moveBtn.onclick = () => {
          setTimeout(() => {
             modal.style.display = 'none';
          resolve(true);
          },300)
        };
      });

      if (!confirmed) return;
      qty = 0;
    } else qty--;
  }

  if (qty === 0) optimisticRemove(item); else optimisticQty(item, qty);
  if (rightCp) rightCp.classList.add('cart-busy-d5');
  try {
    await changeLine(key, qty);
    await rerender();
  } catch (err) {
    console.error(err);
    window.location.reload();
  } finally {
    if (rightCp) rightCp.classList.remove('cart-busy-d5');
  }
});

const SFL_KEY = 'd5-saved-for-later';
function getSavedForLater() {
  try { return JSON.parse(localStorage.getItem(SFL_KEY)) || []; } catch (e) { return []; }
}
function setSavedForLater(items) {
  try { localStorage.setItem(SFL_KEY, JSON.stringify(items)); } catch (e) {}
}
function renderSavedForLater() {
  const items = getSavedForLater();
  const section = document.querySelector('.cd-saved-later-section-d5');
  const list = document.querySelector('.cd-saved-later-list-d5');
  const countEl = document.querySelector('.cd-saved-later-count-d5');
  if (!section || !list) return;
  if (items.length === 0) {
    section.style.display = 'none';
    list.innerHTML = '';
    return;
  }
  section.style.display = '';
  if (countEl) countEl.textContent = '(' + (items.length === 1 ? ((window.mcT && mcT.items_one) || "__N__ item") : ((window.mcT && mcT.items_other) || "__N__ items")).replace('__N__', items.length) + ')';
  list.innerHTML = items.map((it, idx) => `
    <div class="cd-sfl-item-d5 cd-item-row-d5" data-sfl-index="${idx}">
      <a href="${it.url}" class="cd-img-d5"><img src="${it.image}" width="110" height="auto" alt="${it.title}" loading="lazy"></a>
      <div class="cd-item-info-d5">
        <div class="cd-item-title-d5">
          <p class="cd-title-d5"><a href="${it.url}">${it.title}</a></p>
          <div class="cd-price-d5">
            <span class="cd-reg-price-d5">${it.price}</span>
            ${it.comparePrice ? `<span class="cd-comp-price-d5">${it.comparePrice}</span>${it.infoIconHTML ? `<span class="cd-price-info-d5">${it.infoIconHTML}</span>` : ''}<span class="cd-comp-label-d5">${((window.mcT && mcT.comp_value) || "Comp. Value")}</span>` : ''}
          </div>
        </div>
        ${it.announcementHTML ? `<div class="cd-item-announcement-d5">${it.announcementHTML}</div>` : ''}
        ${it.optionsLabel ? `<div class="cd-dropdown-values-d5 cd-sfl-options-d5">${it.optionsLabel}</div>` : ''}
        <div class="cd-sfl-status-d5" data-sfl-status="${idx}" hidden></div>
        <div class="cd-sfl-actions-d5">
          <button type="button" class="cd-sfl-delete-d5" data-sfl-index="${idx}">${((window.mcT && mcT.delete) || "Delete")}</button>
          <button type="button" class="cd-sfl-movetobag-d5" data-sfl-index="${idx}" hidden>${((window.mcT && mcT.move_to_bag) || "Move to Bag")}</button>
        </div>
      </div>
    </div>
  `).join('');
  items.forEach((it, idx) => {
    fetch(`/products/${it.handle}.js`)
      .then(r => r.json())
      .then(product => {
        const variant = (product.variants || []).find(v => v.id === it.variantId) || product.variants[0];
        const statusEl = document.querySelector(`[data-sfl-status="${idx}"]`);
        const moveBtn = document.querySelector(`.cd-sfl-movetobag-d5[data-sfl-index="${idx}"]`);
        if (variant && variant.available) {
          if (moveBtn) moveBtn.hidden = false;
        } else if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = ((window.mcT && mcT.out_of_stock) || "Currently Out of Stock");
        }
      })
      .catch(() => {
        const moveBtn = document.querySelector(`.cd-sfl-movetobag-d5[data-sfl-index="${idx}"]`);
        if (moveBtn) moveBtn.hidden = false;
      });
  });
}
document.body.addEventListener('click', async function (e) {
  const moveBtn = e.target.closest('.cd-sfl-movetobag-d5');
  if (moveBtn) {
    e.preventDefault();
    const idx = parseInt(moveBtn.getAttribute('data-sfl-index'), 10);
    const items = getSavedForLater();
    const it = items[idx];
    if (!it) return;
    moveBtn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: it.variantId, quantity: it.quantity || 1 })
      });
      items.splice(idx, 1);
      setSavedForLater(items);
      await rerender();
      renderSavedForLater();
    } catch (err) {
      console.error(err);
      moveBtn.disabled = false;
    }
    return;
  }
  const delBtn = e.target.closest('.cd-sfl-delete-d5');
  if (delBtn) {
    e.preventDefault();
    const idx = parseInt(delBtn.getAttribute('data-sfl-index'), 10);
    const items = getSavedForLater();
    items.splice(idx, 1);
    setSavedForLater(items);
    renderSavedForLater();
  }
});
renderSavedForLater();

document.body.addEventListener('click', async function (e) {
  const saveBtn = e.target.closest('.cd-save-later-d5');
  if (!saveBtn) return;
  e.preventDefault();
  const item = saveBtn.closest('[line-item]');
  if (!item) return;
  if (!item.closest('.d5-cart-left, #mc-bag-panel')) return; /* drawer lines are handled by d5-script.js */
  const key = item.getAttribute('line-item');
  saveBtn.classList.add('loading');
  try {
    const variantId = parseInt(key.split(':')[0], 10);
    const titleEl = item.querySelector('.cd-title-d5 a');
    const imgEl = item.querySelector('.cd-img-d5 img');
    const priceEl = item.querySelector('.cd-reg-price-d5');
    const compPriceEl = item.querySelector('.cd-comp-price-d5');
    const infoIconEl = item.querySelector('.cd-price-info-d5');
    const announcementEl = item.querySelector('.cd-item-announcement-d5');
    const qtyInput = item.querySelector('.cd-qty-input-d5');
    const optionsEl = item.querySelector('.cd-dropdown-values-d5');
    const saved = getSavedForLater();
    saved.unshift({
      variantId: variantId,
      handle: saveBtn.getAttribute('data-product-url'),
      url: titleEl ? titleEl.getAttribute('href') : ('/products/' + saveBtn.getAttribute('data-product-url')),
      title: titleEl ? titleEl.textContent.trim() : '',
      image: imgEl ? imgEl.src : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      comparePrice: compPriceEl ? compPriceEl.textContent.trim() : '',
      infoIconHTML: infoIconEl ? infoIconEl.innerHTML : '',
      announcementHTML: announcementEl ? announcementEl.innerHTML : '',
      optionsLabel: optionsEl ? optionsEl.innerHTML : '',
      quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
    });
    setSavedForLater(saved);
    optimisticRemove(item);
    renderSavedForLater();
    await changeLine(key, 0);
    await rerender();
  } catch (err) {
    console.error(err);
    saveBtn.classList.remove('loading');
  }
});


  let oldVariantQuantity;
  let oldVariantId;
  document.body.addEventListener('click', async function (e) {
  const trigger = e.target.closest('.cd-item-options-d5')
  if (!trigger) return
  e.preventDefault();
  hideCheckoutElement()
  oldVariantId = trigger.getAttribute('variant-id');
  oldVariantQuantity = trigger.getAttribute('data-quantity');
  const modal = document.querySelector('.cd-variant-update-modal-d5')
  const modalInner = modal.querySelector('.cdv-um-inner-d5')
  const url = trigger.dataset.url
  // BUG FIX (animation): `.active` (which triggers the slide-up transition)
  // used to be added HERE, before the product content was fetched - so the
  // sheet slid up empty and the real size/color options popped in a moment
  // later. Matches the same fix already proven for the Quick Add modal:
  // only reveal the sheet once its real content is already in place.
  try {
    const response = await fetch(url)
    const html = await response.text()
    const temp = document.createElement('div')
    temp.innerHTML = html
    const mainProduct = temp.querySelector('.main-product-d5')
    temp.querySelector('.mp-update-btn-d5').classList.add('disabled');
    modal.classList.add('loading-nul');
    // BUG FIX: without this, opening "Edit Style" for a second item before
    // the modal's own content from a previous open was cleared left TWO
    // .main-product-d5 blocks side-by-side in this flex container, each
    // squeezed to half width. Same proven pattern already used by the
    // color-switch handler elsewhere in this file.
    const oldMainProduct = modalInner.querySelector('.main-product-d5');
    if (oldMainProduct) oldMainProduct.remove();
    if (mainProduct) modalInner.appendChild(mainProduct)
    modal.classList.add('active')
  } catch (error) {
    console.error('Error loading variant options:', error)
  }
   document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
})

  document.body.addEventListener("click",function(e){
    const valueEl=e.target.closest(".mp-value-d5");
    if(!valueEl)return;
    const optionWrapper=valueEl.closest(".mp-option-values-d5");
    if(!optionWrapper)return;
    optionWrapper.querySelectorAll(".mp-value-d5").forEach(el=>el.classList.remove("active"));
    valueEl.classList.add("active");
    document.querySelector('.mp-update-btn-d5').classList.add('disabled');
    const productEl=document.querySelector(".mp-product-json-d5");
    if(!productEl)return;
    const productJson=JSON.parse(productEl.textContent);
    const selectedOptions=[];
    document.querySelectorAll(".mp-option-values-d5").forEach(group=>{
      const active=group.querySelector(".mp-value-d5.active");
      if(active)selectedOptions.push(active.textContent.trim());
    });
    const matchedVariant=productJson.variants.find(v=>v.options.every((opt,i)=>opt===selectedOptions[i]));
    if(matchedVariant){
      const mainProduct=document.querySelector(".main-product-d5");
      if(mainProduct){
        const url=mainProduct.getAttribute("data-url");
        fetch(`${url}&variant=${matchedVariant.id}`)
        .then(res=>res.text())
        .then(html=>{
          const temp=document.createElement("div");
          temp.innerHTML=html;
          const newInfo=temp.querySelector(".mp-product-info-d5");
          const oldInfo=document.querySelector(".mp-product-info-d5");
          const btn = temp.querySelector('.mp-update-btn-d5')
          if(oldVariantId == btn.getAttribute('data-variant')){
            btn.classList.add('disabled');
            // btn.textContent = 'Already in Cart'
          }
          if(newInfo&&oldInfo)oldInfo.innerHTML=newInfo.innerHTML;
            document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
        });
      }
    }
  });

document.body.addEventListener('click', async function (e) {
  const link = e.target.closest('.mp-color-switch-link-d5');
  if (!link) return;
  e.preventDefault();
  const modal = link.closest('.cd-variant-update-modal-d5, .quick-add-modal-d5, .cart-add-modal-d5');
  if (!modal) return;
  const modalInner = modal.querySelector('.cdv-um-inner-d5, .qa-inner-d5');
  if (!modalInner) return;
  const url = link.dataset.url;
  try {
    const response = await fetch(url);
    const html = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const mainProduct = temp.querySelector('.main-product-d5');
    if (mainProduct) {
      const oldMainProduct = modalInner.querySelector('.main-product-d5');
      if (oldMainProduct) oldMainProduct.remove();
      modalInner.appendChild(mainProduct);
    }
  } catch (error) {
    console.error('Error switching color:', error);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const updateBtn = e.target.closest('#cart-drawer-d5 .mp-update-btn-d5');
  if (!updateBtn || updateBtn.classList.contains('disabled')) return;
  e.preventDefault();
  const newVariantId = updateBtn.getAttribute('data-variant');
  if (!oldVariantId || !newVariantId || oldVariantId === newVariantId) return;
  const modal = document.querySelector('.cd-variant-update-modal-d5');
  closeModal(select = '.cd-variant-update-modal-d5');
  drawer.classList.add('atc-loading-d5');
  setTimeout(() => {
     drawer.classList.add('active');
  }, 200);
  const qty = oldVariantQuantity ? oldVariantQuantity : 1
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldVariantId, quantity: 0 })
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newVariantId, quantity: qty })
    });
    await rerender();
    modal.classList.remove('active');
  } catch (error) {
    console.error('Error updating variant:', error);
  } finally {
    drawer.classList.remove('atc-loading-d5');
  }
});

function closeModal(select) {
  const modal = document.querySelector(select);
  const appendedSection = modal.querySelector('.main-product-d5');
  if (appendedSection) appendedSection.remove();
  modal.classList.remove('active', 'loading-nul');
  showCheckoutElement();
}

document.body.addEventListener("click", function (e) {
  if (e.target.hasAttribute('close-update-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
  }
  if (e.target.hasAttribute('qa-close-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
    closeModal(select = '.cart-add-modal-d5 .qa-inner-d5');
    document.querySelector('.quick-add-modal-d5').classList.remove('active', 'loading-nul');
    document.querySelector('.cart-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});


 window.rerender = async function () {
  const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart?section_id=main-cart', { credentials: 'same-origin' });
  const text = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const emptyCart = doc.querySelector('[render-empty-cart]');
  const emptyCon = document.querySelector('.empty-cart-d5')
  if(emptyCart && emptyCon){
    emptyCon.innerHTML = emptyCart.innerHTML

}else {
   const newElems = doc.querySelectorAll('[cp-render-d5]');
  const currentElems = document.querySelectorAll('[cp-render-d5]');
  const oldCount = document.querySelector('.cart-count-d5');
  const newCount = doc.querySelector('.cart-count-d5');
  if(oldCount && newCount){
    oldCount.innerHTML = newCount.innerHTML;
  }
  currentElems.forEach((el, i) => {
    const newEl = newElems[i];
    if (newEl) el.innerHTML = newEl.innerHTML;
  });
}
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
  /* The bag icon used to be copied from the section HTML, which fails once the page is in its empty-bag layout
     (e.g. Save for Later -> Move to Bag left the icon at 0 with 1 item). Always resync from the real cart. */
  try {
    const cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
    if (cart && typeof cart.item_count === 'number') {
      setCartCounts(cart.item_count);
      if (cart.item_count > 0 && !document.querySelector('.d5-cart-left [line-item]') && emptyCart == null) { window.location.reload(); }
    }
  } catch (e) {}
};
// const cpOpener = document.querySelector('.cp-mob-total-d5');



document.body.addEventListener('click', e =>{
  if(e.target.classList.contains('cp-mob-total-d5')){
    e.preventDefault();
    rightCp.classList.add('active');
  }
  if(e.target.hasAttribute('cr-close-d5')){
    e.preventDefault();
    rightCp.classList.remove('active');
  }
})
function applyDiscountCode() {
  const discountBar = document.querySelectorAll('.discount-field-d5');
  discountBar.forEach(bar => {
    const discountInput = bar.querySelector(".discount-input-d5");
    const appliedDiscounts = bar.querySelector(".applied-discounts-d5");
    const failedDiscounts = bar.querySelector(".failed-discounts-d5");
    document.body.addEventListener("click", function(event) {
      if (event.target.classList.contains("discount-button-d5")) {
        event.preventDefault();
        event.target.classList.add('loading');

        const discountCode = discountInput.value.trim();

        if (discountCode) {
          fetch(`/discount/${discountCode}`)
            .then(data => {
              fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart')
                .then(cartResponse => cartResponse.text())
                .then(cartHTML => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(cartHTML, 'text/html');
                  const lis = doc.querySelectorAll('.applied-discounts-d5 li');
                  lis.forEach(l => {
                    if (l.dataset.code == discountCode) {
                      const newElem = doc.querySelectorAll('[discount-render-d5]');
                      const oldElem = document.querySelectorAll('[discount-render-d5]');
                      oldElem.forEach((elem, index) => {
                        elem.innerHTML = newElem[index].innerHTML;
                      });
                    } else {
                      failedDiscounts.classList.add('active');
                    }
                  });
                })
                .catch(cartError => {
                  console.error('Error fetching cart:', cartError);
                });
            })
            .catch(discountError => {
              console.error('Error applying discount:');
            }).finally(() => {
              event.target.classList.remove('loading');
            })
            event.target.classList.add('loading');
        } else {
          event.target.classList.remove('loading');
        }
      }
    });
  });
}


applyDiscountCode()

document.addEventListener('click',async function(e){
  const el=e.target.closest('.pc-product-add-btn-d5');
  const modal = document.querySelector('.cart-add-modal-d5');
  if(!el)return;
  e.preventDefault();
  const url=el.getAttribute('data-url');
  hideCheckoutElement()
  if(!url)return;
  // BUG FIX (animation): `.active` used to be added HERE, before the
  // product content was fetched - same "empty sheet slides up, then
  // content pops in" bug already fixed on the Quick Add modal elsewhere.
  // Only reveal the sheet once its real content is already appended.
  try{
    const response=await fetch(url);
    if(!response.ok)throw new Error();
    const htmlText=await response.text();
    const parser=new DOMParser();
    const doc=parser.parseFromString(htmlText,'text/html');
    const productContent=doc.querySelector('.main-product-d5');
    if(!productContent)return;
    const targetContainer=modal.querySelector('.qa-inner-d5');
    if(!targetContainer)return;
    const oldProductContent=targetContainer.querySelector('.main-product-d5');
    if(oldProductContent)oldProductContent.remove();
    targetContainer.appendChild(productContent);
    modal.classList.add('loading-nul');
    /* shared markup with "Edit Style": relabel for the add-a-new-product context (FN: "QUICK ADD") */
    const qaHeader = productContent.querySelector('.mp-header-d5 p');
    if (qaHeader) qaHeader.textContent = ((window.mcT && mcT.quick_add) || "Quick Add");
    modal.classList.add('active');
  }catch(err){
    console.error(err);
  }
   document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const button = e.target.closest('.cart-add-modal-d5 .atc-btn-d5');
  if(!button) return null;
  const variantId = button.getAttribute('data-variant');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  button.classList.add('disabled')

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    const data = await res.json();
    await rerender(data.key);
  } catch (err) {
    console.error(err);
  }finally{
    closeModal(select = '.cart-add-modal-d5 .qa-inner-d5');
    document.querySelector('.cart-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});

document.body.addEventListener('click', (e) => {
  if(e.target.classList.contains('final-item-opener-d5')){
    e.preventDefault();
    document.querySelector('.final-item-modal-d5').classList.add('active');
    hideCheckoutElement()

  }
  if(e.target.hasAttribute('fi-close-d5')){
    e.preventDefault();
    showCheckoutElement();
    document.querySelector('.final-item-modal-d5').classList.remove('active');
  }
})
/* "+ Add items" (sticky bar) and "Add & Unlock" (free-shipping card): like Fashion Nova, stay on the page and
   smooth-scroll so the "Recently Viewed" / "For You" rows land at the top of the screen (under any sticky header). */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.cd-more-btn-d5, .cp-shipping-nudge-btn-d5');
  if (!trigger) return;
  const target = document.querySelector('.extra-product-tabs-d5 .ct-section-d5') || document.getElementById('ext-products-d5');
  if (!target) return;
  e.preventDefault();
  let offset = 0;
  const header = document.querySelector('header, .custom-header');
  if (header) {
    const pos = getComputedStyle(header).position;
    if (pos === 'fixed' || pos === 'sticky') offset = header.getBoundingClientRect().height;
  }
  const top = target.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
});


/* "Product Details" accordion inside the Quick Add sheet on the cart page (the same delegated toggle lives in d5-script.js,
   which is not loaded on /cart). */
document.body.addEventListener('click', function (e) {
  const container = e.target.closest('.cart-add-modal-d5 [data-testid="accordion-container"], .cd-variant-update-modal-d5 [data-testid="accordion-container"]');
  if (!container) return;
  const wrapper = container.closest('[data-testid="accordion-wrapper"]');
  if (!wrapper) return;
  const childContainer = wrapper.querySelector('[data-testid="accordion-children-container"]');
  const arrow = wrapper.querySelector('.arrow');
  if (!childContainer) return;
  const expanded = childContainer.getAttribute('data-expanded') === 'true';
  childContainer.style.maxHeight = expanded ? '0px' : childContainer.scrollHeight + 'px';
  if (arrow) arrow.style.transform = expanded ? 'rotate(270deg)' : 'rotate(90deg)';
  childContainer.setAttribute('data-expanded', expanded ? 'false' : 'true');
});
